import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OtpScreen from './users/OtpScreen';
import AddressScreen from './users/AddressScreen';

function App() {
  return (
    <Routes>
      <Route path="/" element={<OtpScreen />} />
      <Route path="/address" element={<AddressScreen />} />
    </Routes>
  );
}

export default App;
